import { render, staticRenderFns } from "./myCorrection.vue?vue&type=template&id=5da7ccf9&"
import script from "./myCorrection.vue?vue&type=script&lang=js&"
export * from "./myCorrection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports